import { EFeaturesActionType, IFeaturePropertiesUpdateParameters } from './types';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const updateFeatureProperties = actionGenerator<
  EFeaturesActionType.FeaturePropertiesUpdated,
  IFeaturePropertiesUpdateParameters
>(EFeaturesActionType.FeaturePropertiesUpdated);
